import actions from './actions';

const initialState = {
    notas: [],
    currentNota: {}
};

export default function notasCierreReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_NOTAS_CIERRE_SUCCESS:
            return {
                ...state,
                notas: action.payload,
            }
        case actions.CREATE_NOTAS_CIERRE_SUCCESS:
            return {
                ...state,
                notas: [...state.notas, action.payload]
            }
        case actions.EDIT_NOTAS_CIERRE_SUCCESS:
            return {
                ...state,
                notas: state.notas.map(nota => nota._id === action.payload._id ? action.payload : nota)
            }
        case actions.DELETE_NOTAS_CIERRE_SUCCESS:
            return {
                ...state,
                notas: state.notas.filter(nota => nota._id !== action.payload)
            }
        case actions.SET_CURRENT_NOTA_CIERRE:
            return {
                ...state,
                currentNota: action.payload
            }
        default:
            return state;
    }

}
